import {Flex, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const TitleOnly = () => {
  const {t} = useTranslation('payerStatements')

  return (
    <Flex alignItems="center">
      <Text textStyle={{base: 'headline3', md: 'headline2'}}>
        {t('header.title')}
      </Text>
    </Flex>
  )
}

export default TitleOnly
